module.exports = __webpack_public_path__ + "static/media/friend.b52303c9.png";